import { render, staticRenderFns } from "./edit-prescription.component.vue?vue&type=template&id=15a6b584&scoped=true&"
import script from "./edit-prescription.component.vue?vue&type=script&lang=js&"
export * from "./edit-prescription.component.vue?vue&type=script&lang=js&"
import style0 from "./edit-prescription.component.vue?vue&type=style&index=0&id=15a6b584&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a6b584",
  null
  
)

export default component.exports